import { EnumTipoComunicacao, KeyValueModel } from "model";

export const TpComunicacaoMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoComunicacao.Boleto, "Boleto"),
    new KeyValueModel(EnumTipoComunicacao.Pix, "Pix"),
    new KeyValueModel(EnumTipoComunicacao.PixSplit, "Pix S2Pay"),
    new KeyValueModel(EnumTipoComunicacao.Transferencia, 'Transferência'),
    new KeyValueModel(EnumTipoComunicacao.Dinheiro, 'Dinheiro')
];
